import { useTranslation } from "react-i18next"

import { CheckCircle2, XCircle } from "@/components/icons"
import { ensureArray } from "@/features/training/utils/ensure-array"

export function DosAndDontsCard() {
  const { t } = useTranslation("", { keyPrefix: "training.components.dos_donts" })
  const dos = ensureArray<string>(t("dos", { returnObjects: true }))
  const donts = ensureArray<string>(t("donts", { returnObjects: true }))

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      {/* Do's */}
      <div className="border-success bg-success/15 text-foreground rounded-xl border p-5">
        <div className="mb-3 flex items-center gap-2">
          <CheckCircle2 className="text-success h-5 w-5" />
          <h4 className="text-success text-base font-bold">{t("dos_title", "Do's")}</h4>
        </div>
        <ul className="space-y-2">
          {dos.map((item, i) => (
            <li key={i} className="flex items-start gap-2 text-sm">
              <span className="text-success mt-0.5">-</span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* Don'ts */}
      <div className="border-destructive bg-destructive/15 text-foreground rounded-xl border p-5">
        <div className="mb-3 flex items-center gap-2">
          <XCircle className="text-destructive h-5 w-5" />
          <h4 className="text-destructive text-base font-bold">{t("donts_title", "Don'ts")}</h4>
        </div>
        <ul className="space-y-2">
          {donts.map((item, i) => (
            <li key={i} className="flex items-start gap-2 text-sm">
              <span className="text-destructive mt-0.5">-</span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
